import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- svg needs attribute selectors
  selector: '[h3MissingShapeFeedbackMarker]',
  templateUrl: './missing-shape-feedback-marker.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MissingShapeFeedbackMarkerComponent {}
